import React from 'react'
import { Link } from 'react-router-dom'
import posed from 'react-pose'
import ArrowRightIcon from '../assets/icons/icon-arrow-right.svg'

const PosedLink = posed.div({
  start: { opacity: 0, y: '20px' },
  end: {
    opacity: 1,
    y: '0px',
    delay: 1500,
    transition: {
      duration: 500,
    },
  },
})

const FAQLink = ({ storeData, href }) => {
  const storeDetails = storeData
    ? {
        name: storeData.storeName,
        mobileNumber: storeData.mobileNumber,
      }
    : {}

  return (
    <PosedLink initialPose="start" pose="end">
      <Link to={{ pathname: href, state: storeDetails }}>
        <div
          data-cy="faq-contact-us"
          className="flex px-4 py-3 mb-4 border rounded-lg cursor-pointer border-secondary bg-body-lightest text-secondary"
        >
          <div className="flex-1 px-3">
            <p className="font-semibold select-none">Any issues? See FAQs</p>
          </div>
          <span className="self-center block">
            <img
              src={ArrowRightIcon}
              alt="open store details"
              className="block w-4 h-3"
            />
          </span>
        </div>
      </Link>
    </PosedLink>
  )
}

export default FAQLink
